module.exports = __webpack_public_path__ + "img/icon_3_29.0aa29ec9.png";